export const initialState = {
    galleryList: [],
    activeGallery: null,
    galleryImageList: []
};